<template>
  <v-card class="consignor-form">
    <v-card-title v-if="!update">Create a New Consignor</v-card-title>
    <v-card-title v-else>Update {{ adminConsignor.name }}</v-card-title>
    <v-card-text>
      <v-alert
        type="error"
        v-if="errorMsg"
      >
        {{ errorMsg }}
      </v-alert>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="consignor.name"
          label="Name"
          :rules="textRules"
          required
        ></v-text-field>

        <v-autocomplete
          v-model="consignor.managerId"
          :loading="searchLoading"
          :items="adminUserSearchResults"
          item-text="emailAddress"
          item-value="id"
          :search-input.sync="search"
          cache-items
          prepend-icon="mdi-account-search"
          :placeholder="user.emailAddress"
          flat
          label="Consignor Manager"
        ></v-autocomplete>

        <v-row>
          <v-col md=10>
            <v-file-input
              accept="image/*"
              label="Consignor Image"
              prepend-icon="mdi-camera"
              show-size
              :loading="consignorImageLoading"
              @change="setConsignorImage"
            >
            </v-file-input>
          </v-col>
          <v-col md=2>
            <v-img :src="adminConsignor.imageUrl"></v-img>
          </v-col>
        </v-row>

        <MetaFieldLongText
          v-model="consignor.description"
          :metadata="{title: 'Description'}"
          ></MetaFieldLongText>

      </v-form>
    </v-card-text>
    <v-card-actions
      class="mt-3"
    >
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        v-if="!update"
        @click="createSubmit"
      >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Create
      </v-btn>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        v-else
        @click="updateSubmit"
      >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Update
      </v-btn>
      <v-btn
        @click="clearAndClose"

      >
        <v-icon left>
          mdi-cancel
        </v-icon>
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import MetaFieldLongText from './MetaFieldLongText.vue'

  export default {
    name: 'ConsignorForm',

    components: {
      MetaFieldLongText
    },

    computed: {
      ...mapGetters([
        'adminConsignor',
        'adminUserSearchResults',
        'user'
      ])
    },

    data: () => ({
      // Form validation handling.
      loading: false,
      consignorImageLoading: false,
      valid: true,
      errorMsg: '',
      textRules: [
        v => !!v || 'This fields is required.'
      ],

      // User search.
      searchLoading: false,
      userSelect: null,
      search: null,

      // Consignor payload.
      consignor: {
        id: '',
        description: '',
        name: '',
        managerId: ''
      },
      consignorImage: {},

      update: false
    }),

    methods: {
      ...mapActions([
        'createConsignor',
        'updateConsignor',
        'updateConsignorImage',
        'userSearch'
      ]),

      // Querying on the users.
      searchUsers (q) {
        this.searchLoading = true

        this.userSearch(q).then(() => {
          this.searchLoading = false
        }).catch(() => {
          this.searchLoading = false
        })
      },

      setConsignorImage(file) {
        if (file !== undefined) {
          this.consignorImage = file
          if (this.update) {
            this.uploadConsigImage()
          }
        }
        else {
          this.consignorImage = {}
        }
      },

      uploadConsigImage: function () {
        this.consignorImageLoading = true

        this.updateConsignorImage({
          consignorId: this.adminConsignor.id,
          file: this.consignorImage
        })
        .then(() => {
          this.consignorImageLoading = false
        })
        .catch(() => {
          console.error('There was a problem uploading consignor image.')
        })
      },

      clearAndClose: function () {
        // Clear
        this.$refs.form.reset()
        // Close
        this.$emit('dialogClose')
      },

      createSubmit: function () {
        // Set the loader
        this.loading = true

        // Pass in me if no user is selected.
        if (!this.consignor.managerId) {
          this.consignor.managerId = this.user.id
        }

        // Create consignor.
        this.createConsignor(this.consignor).then(async () => {
          // Upload the image if we got one.
          if (this.consignorImage.name !== undefined) {
            await this.uploadConsigImage()
          }
        })
        .then(() => {
          this.$emit('dialogClose')
        })
        .catch((error) => {
          // Oops.
          this.loading = false
          this.errorMsg = 'Something went wrong, please check your submission and try again.'
          console.error(error)
        })
      },

      updateSubmit: function () {
        // Set the loader
        this.loading = true

        this.updateConsignor(this.consignor).then(() => {
          this.$emit('dialogClose')
        }).catch(() => {
          this.loading = false
          this.errorMsg = 'Something went wrong, please check your submission and try again.'
        })
      },

      // Are we updating?
      updateCheck: function () {
        this.loading = false

        // If adminAsset exists in state then we're updating.
        if (typeof this.adminConsignor.id !== 'undefined') {
          // Set the consignor data from state.
          this.consignor = Object.assign({}, this.adminConsignor)
          this.consignor.managerId = this.adminConsignor.manager.id
          this.search = this.consignor.manager.emailAddress
          delete this.consignor.manager

          this.update = true
        }
        else {
          // Clear
          this.$refs.form.reset()
        }
      }
    },

    mounted() {
      this.updateCheck()
    },

    watch: {
      adminConsignor: 'updateCheck',
      search (val) {
        val && val !== this.userSelect && this.searchUsers(val)
      }
    }
  }
</script>
